import { useTranslation } from "react-i18next";
import { SelectButton } from "primereact/selectbutton";
import { TREND_FILTER_TYPE } from "../../../../models/pages/biometrics/biometrics-trends-filters";

const BiometricsTrendsFilters = ({
	filters,
	onFiltersChange,
}: {
	filters: { type: TREND_FILTER_TYPE };
	onFiltersChange: (e: { type: TREND_FILTER_TYPE }) => void;
}) => {
	const { t } = useTranslation("common");

	return (
		<div className="row chart-filters">
			{/* Chart type */}
			<div className="col-12 col-md-6 chart-filter-col">
				<span className="chart-filter-title">
					{t("PARTICIPANT.BIOMETRICS.CHARTS.CHART_TYPE")}
				</span>
				<SelectButton
					className="chart-selector"
					value={filters.type}
					onChange={(e) => onFiltersChange({ type: e.value })}
					options={[
						{
							id: TREND_FILTER_TYPE.GLUCOSE,
							label: t("PARTICIPANT.BIOMETRICS.CHARTS.GLUCOSE_ALL"),
						},
						{
							id: TREND_FILTER_TYPE.GLUCOSE_FASTING,
							label: t("PARTICIPANT.BIOMETRICS.CHARTS.GLUCOSE_FASTING"),
						},
						{
							id: TREND_FILTER_TYPE["GLUCOSE_PRE-MEAL"],
							label: t("PARTICIPANT.BIOMETRICS.CHARTS.GLUCOSE_PRE_MEAL"),
						},
						{
							id: TREND_FILTER_TYPE["GLUCOSE_POST-MEAL"],
							label: t("PARTICIPANT.BIOMETRICS.CHARTS.GLUCOSE_POST_MEAL"),
						},
						{
							id: TREND_FILTER_TYPE.GLUCOSE_UNLABELED,
							label: t("PARTICIPANT.BIOMETRICS.CHARTS.GLUCOSE_UNLABELED"),
						},
					]}
					optionLabel="label"
					optionValue="id"
				/>
			</div>
		</div>
	);
};

export default BiometricsTrendsFilters;
